import { useMemo } from 'react';
import { QBox, QMenuButton } from '@qualio/ui-components';
import { FieldType, FieldTypeSchema } from '../../../../../types/formFields/common';
import { mapRegularFieldToButton } from '../shared';

type AddFieldParams = {
  addField: (field: FieldType) => void;
  buttonLabel: string;
  variant?: 'outline' | 'link';
};

const FieldsToDisplay = [
  FieldTypeSchema.enum.text,
  FieldTypeSchema.enum.rich_text,
  FieldTypeSchema.enum.date,
  FieldTypeSchema.enum.numeric,
  FieldTypeSchema.enum.boolean,
  FieldTypeSchema.enum.attachment,
  FieldTypeSchema.enum.dropdown,
  FieldTypeSchema.enum.section,
  FieldTypeSchema.enum.checkbox,
  FieldTypeSchema.enum.radio,
] as const;

const AddField = ({ addField, buttonLabel, variant = 'link' }: AddFieldParams) => {
  const ButtonOptions = useMemo(() => {
    return FieldsToDisplay.map(mapRegularFieldToButton).sort((a, b) => a.label.localeCompare(b.label));
  }, []);

  return (
    <QBox data-cy={'add-field-menu'}>
      <QMenuButton
        buttonLabel={buttonLabel}
        itemSize="sm"
        items={ButtonOptions}
        onItemClick={(event) => addField(event.id as FieldType)}
        variant={variant}
        aria-label="create-new-field"
      />
    </QBox>
  );
};

export default AddField;
